var React = require('react');

function PlayButton (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"27.6714","cy":"28","r":"26.9262","stroke":"white","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M35.6816 28L22.8282 37.8738L22.8282 18.1262L35.6816 28Z","fill":"white","stroke":"white","strokeWidth":"2","strokeLinejoin":"round","key":1})]);
}

PlayButton.defaultProps = {"width":"56","height":"56","viewBox":"0 0 56 56","fill":"none"};

module.exports = PlayButton;

PlayButton.default = PlayButton;
